export default "__VITE_ASSET__CciAaUH8__"